import React from 'react';
import PropTypes from 'prop-types';
import Close from '@material-ui/icons/Close';
import Done from '@material-ui/icons/Done';
import Help from '@material-ui/icons/Help';
import { FormattedMessage } from 'react-intl';
import {
  withStyles,
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Typography,
  CircularProgress,
  LinearProgress,
  Hidden,
} from '@material-ui/core';

const styles = (theme) => ({
  appBar: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      minWidth: 600,
    },
    backgroundColor: theme.palette.beige[75],
    color: '#333',
  },
  flex: {
    flex: 1,

    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9rem',
    },
  },
  children: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 56px)',

    [theme.breakpoints.up('md')]: {
      maxHeight: 'calc(100vh - 160px)',
    },
  },
  progress: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
});

const DialogTemplate = ({
  children,
  classes,
  isUpdating,
  pristine,
  progress,
  title,

  onClose,
  onSave,
}) => (
  <div>
    <AppBar className={classes.appBar}>
      <Toolbar>
        {onClose && (
          <IconButton
            color="inherit"
            aria-label="Close"
            onClick={onClose}
          >
            <Close />
          </IconButton>
        )}
        <Typography
          variant="subtitle1"
          color="inherit"
          className={classes.flex}
        >
          {title}
        </Typography>
        {onSave && (
          <Button
            color="inherit"
            onClick={onSave}
            disabled={isUpdating || pristine}
          >
            {isUpdating ?
              <CircularProgress color="inherit" size={24} /> :
              <Done />}
            <FormattedMessage
              id="Save"
              defaultMessage="Save"
            />
          </Button>
        )}
        {window.supportHeroWidget && (
          <Hidden xsDown>
            <IconButton
              aria-label="Help"
              onClick={window.supportHeroWidget.show}
            >
              <Help />
            </IconButton>
          </Hidden>
        )}
      </Toolbar>
    </AppBar>
    {(progress || progress === 0) && (
      <LinearProgress
        variant="determinate"
        value={progress}
        className={classes.progress}
      />
    )}
    <div id="edit-dialog-scroll" className={classes.children}>
      {children}
    </div>
  </div>
);

DialogTemplate.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({}).isRequired,
  isUpdating: PropTypes.bool,
  pristine: PropTypes.bool,
  progress: PropTypes.number,
  title: PropTypes.node,

  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default withStyles(styles)(DialogTemplate);
